import { useTranslation } from 'react-i18next'

import { ComboBox, InputWithLabel } from '@reveni-io/reveni-ui'

import { optionTypes } from './constants'
import * as Styles from './styles'

const DynamicDates = ({ onChangeValue, onChangeType, type, value }) => {
  const { t } = useTranslation()

  return (
    <Styles.DynamicDatesContainer>
      <p>{t('Solicitado hace')}</p>
      <InputWithLabel type="number" value={value} onChange={onChangeValue} />
      <p>{t('días')}</p>
      <ComboBox
        value={type}
        menuItems={optionTypes.map(type => ({
          label: t(type.label),
          value: type.value,
        }))}
        handleChange={onChangeType}
      />
    </Styles.DynamicDatesContainer>
  )
}

export default DynamicDates
